export const projects = [
  {
    title: "Tracking Ambulans Dinas Kesehatan Kota Surakarta",
    subtitle: "Internet Of Things and CodeIgnite 3",
    description:
      "Internet Of Things Tracking Ambulance is a project developed to monitor the position of ambulances in the city of Surakarta",
    image: "./project-1.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "DIGIPAY 009",
    subtitle: "YII2",
    description:
      "Digipay is a marketplace application built to facilitate government agencies in the process of procuring goods and services.",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  // {
  //   title: "DevChat",
  //   subtitle: "React and Firebase",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-3.gif",
  //   link: "https://reactbootcamp.com",
  // },
  // {
  //   title: "Epic Todo App",
  //   subtitle: "React Hooks",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-4.gif",
  //   link: "https://reactbootcamp.com",
  // },
];

export const certificate = [
  {
    title:
      "Belajar Dasar Pemrograman JavaScript",
      image: "./certificate/1.jpg",
  },
  {
    title:
      "MikroTik Certified Network Associate (MTCNA)",
      image: "./certificate/4.jpg",
  },
  {
    title:
      "Belajar Dasar Pemrograman Web",
      image: "./certificate/3.jpg",
  },
  {
    title:
      "Cloud Practitioner Essentials (Belajar Dasar AWS Cloud)",
      image: "./certificate/2.jpg",
  },
  {
    title:
      "Belajar Membuat Aplikasi Back-End untuk Pemula",
      image: "./certificate/2.jpg",
  },
  {
    title:
      "Belajar Membuat Front-End Web untuk Pemula",
      image: "./certificate/5.jpg",
  },
 
];

export const skills = [
  "JavaScript",
  "PHP",
  "RESTFUL API",
  "SQL",
];

export const sosmed = [
  {
    name: "LinkedIN",
    url: "https://www.linkedin.com/in/rendi-jaka-susanto-96b0401b4/",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/rendi.jaka/",
  },
];



// WEBPACK FOOTER //
// ./src/data.js